import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { get, isEmpty } from 'lodash';
// Material Imports
import Grid from '@material-ui/core/Grid';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { liveWebinarRequest } from '../../../../actions/liveWebinarActions';
// Styles
import './styles.scss';
import '../../../../css/styles.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';
// Components
// import VideoPlayer from '../../../../components/VideoPlayer';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';
import NoData from '../../../../components/NoData';

export default function LiveWebinarLecture() {
  // State
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  // Redux Store
  const dispatch = useDispatch();
  const loginData = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const videoData = useSelector(state =>
    get(state, 'liveWebinarReducer.data', {})
  );
  const errorMessage = useSelector(state =>
    get(state, 'liveWebinarReducer.errorMessage', 'No data Available')
  );

  // let classTitle, subject;
  // if (videoData) {
  //   classTitle = videoData.ClassTitle;
  //   subject = videoData.SubjectName;
  //   // classNo = videoData.ClassNo;
  // }
  // useEffect(() => {
  //   setUniqueCode(unique);
  //   setModuleCode(module);
  // });

  useEffect(() => {
    setIsVideoLoading(true);
    liveWebinarRequest(loginData, dispatch).then(() => {
      setIsVideoLoading(false);
    });
  }, []);

  // const moduleHandler = (unique, module) => {
  //   setUniqueCode(unique);
  //   setModuleCode(module);
  // };

  // const populateModuleData = () => {
  //   const moduleData = [];
  //   get(videoData, 'listClass', []).map((data, index) => {
  //     return moduleData.push(
  //       <Link
  //         to={'/digital-classroom/' + data.UniqueCode + '/' + data.ModuleCode}
  //         key={index}
  //       >
  //         <ModuleCard
  //           subject={subject}
  //           subjectTitle={classTitle}
  //           module={data.ModuleNo}
  //           selected={index === selectedIndex}
  //           handler={() => {
  //             setSelectedIndex(index);
  //             moduleHandler(data.UniqueCode, data.ModuleCode);
  //           }}
  //         />
  //       </Link>
  //     );
  //   });
  //   return moduleData;
  // };

  // const populateClassMaterial = () => {
  //   const classData = [];
  //   get(videoData, 'listNotes', []).map((data, index) => {
  //     return classData.push(
  //       <li key={index}>
  //         <a
  //           href={data.Value}
  //           target="_blank"
  //           rel="noopener noreferrer"
  //           className="text"
  //         >
  //           {data.Text}
  //         </a>
  //       </li>
  //     );
  //   });
  //   return classData;
  // };

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          {isVideoLoading ? (
            <LoadingSkeleton type="image" height="400px" />
          ) : get(videoData, 'WebinarURL', '') ? (
            <div className="video-container">
              <Link to={`/digital-classroom`} className="back-btn">
                <ArrowBackIcon /> Back
              </Link>
              <div className="video-header">
                <div className="flex-row flex-space-between">
                  <div className="class-text">
                    {get(videoData, 'WebinarTitle', '')}
                  </div>
                </div>
                <div className="video-header-title">
                  <h3 className="topic-text">
                    {get(videoData, 'WebinarTime', '')}
                  </h3>
                </div>
              </div>
              <div className="video-player">
                <iframe
                  width="560"
                  height="315"
                  src={`https://www.youtube.com/embed/${get(
                    videoData,
                    'WebinarURL',
                    ''
                  )}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          ) : (
            <NoData
              message={
                !isEmpty(errorMessage) ? errorMessage : 'No data Available'
              }
            />
          )}
          {/* <div className="info-text">
            <span className="imp-text">Important:</span>
            Above video classes are copyrighted and copyright of these classes
            is reserved with ALLEN. Capturing, downloading and sharing of these
            classes is a criminal and punishable offense. All viewers are
            advised to refrain in involving any such activity.
          </div> */}
        </Grid>
        {/* <Grid item xs={12} sm={12} md={4}>
          <div className="video-right-panel">
            {isVideoLoading ? (
              <LoadingSkeleton type="moduleList" />
            ) : (
              <PerfectScrollbar>
                {!isEmpty(videoData) &&
                  videoData.listClass &&
                  populateModuleData()}
              </PerfectScrollbar>
            )}
          </div>
        </Grid> */}
      </Grid>
      {/* {isVideoLoading ? (
        <LoadingSkeleton type="card" />
      ) : (
        !isEmpty(videoData) &&
        !isEmpty(videoData.listNotes) && (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={8}>
              <div className="video-homework mt-30">
                <h3 className="title-heading">Class Homework</h3>
                <ul className="homework-data">{populateClassMaterial()}</ul>
              </div>
            </Grid>
          </Grid>
        )
      )} */}
      {/* <DigitalClassroomLayout /> */}
    </React.Fragment>
  );
}
